import { ColumnHeaderValidation } from './column-header-validation';
import { XactionFileImportCleaningRecord } from './xaction-file-import-cleaning-record';

export class XactionFileImportPacket {
    cleanedRecords: XactionFileImportCleaningRecord[];
    headers: ColumnHeaderValidation;
}
